import React, {useState, useEffect} from 'react';
import {handleInputChange} from "src/components/form/formHandler";
import {postChangePasswordRequest, postForgotPasswordChangeByHash} from "src/api/user/forgotPassword.ts";
import {Link, useSearchParams} from "react-router-dom";
import {handleApiError} from 'src/api/errorHandler.ts';
import {Alert, Button, TextField, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import PasswordField from "src/components/form/PasswordField";
import Grid2 from "@mui/material/Unstable_Grid2";

const ForgotPasswordPage = () => {
  const initialFormValues = {
    'email': '',
    'password': '',
    'repeatPassword': '',
  };
  const [formValues, setFormValues] = useState(initialFormValues)
  const [formErrors, setFormErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [hash, setHash] = useState(null);

  useEffect(() => {
    setHash(searchParams.get('hash'));
  }, [])

  const handleForgotPasswordRequestSubmit = async (e) => {
    e.preventDefault();
    setShowSuccess(false);
    setFormErrors({});
    try {
      await postChangePasswordRequest(formValues.email);
      setShowSuccess(true);
      setFormValues(initialFormValues);
    } catch (e) {
      handleApiError(e, setFormErrors);
    }
  }

  const handleSetNewPasswordSubmit = async (e) => {
    e.preventDefault();
    setShowSuccess(false);
    setFormErrors({});
    try {
      await postForgotPasswordChangeByHash(hash, formValues.password, formValues.repeatPassword);
      setShowSuccess(true);
      setFormValues(initialFormValues);
    } catch (e) {
      handleApiError(e, setFormErrors);
    }
  }

  if (hash) {
    return (
      <>
        <p><Link to="/login">Terug naar login</Link></p>
        <Typography variant="h2" mb={2}>Nieuw wachtwoord instellen</Typography>
        <form>
          <Grid2 container>
            <Grid2 xs={12}>
              <PasswordField
                name="password"
                label="Nieuw wachtwoord"
                value={formValues.password}
                onChange={(e) => handleInputChange(e, formValues, setFormValues)}
                error={'password' in formErrors}
                helperText={formErrors.password}
                margin="dense"
                sx={{width: '400px'}}
                required
              />
            </Grid2>

            <Grid2 xs={12}>
              <PasswordField
                name="repeatPassword"
                label="Herhaal nieuw wachtwoord"
                value={formValues.repeatPassword}
                onChange={(e) => handleInputChange(e, formValues, setFormValues)}
                error={'confirmPassword' in formErrors}
                helperText={formErrors.confirmPassword}
                margin="dense"
                sx={{width: '400px'}}
                required
              />
            </Grid2>
          </Grid2>

          <Box mt={2}>
            {showSuccess && <Alert severity="success">Je wachtwoord is aangepast.</Alert>}
            {formErrors.changePasswordRequestHash && <Alert severity="error">{formErrors.changePasswordRequestHash}</Alert>}
          </Box>

          <Box mt={3}>
            <Button
              onClick={handleSetNewPasswordSubmit}
              variant="contained"
            >
              Versturen
            </Button>
          </Box>
        </form>
      </>
    );
  }

  return (
    <>
      <p><Link to="/login">Terug naar login</Link></p>
      <Typography variant="h2" mb={2}>Wachtwoord vergeten</Typography>
      <form>
        <TextField
          name="email"
          label="E-mailadres"
          value={formValues.email}
          onChange={(e) => handleInputChange(e, formValues, setFormValues)}
          error={'userEmail' in formErrors}
          helperText={formErrors.userEmail}
          autoComplete="username"
          margin="dense"
          sx={{width: '400px'}}
          required
        />

        {showSuccess && <Alert severity="success">Er is een e-mail verstuurd met instructies, indien het opgegeven e-mailadres bij ons bekend is.</Alert>}

        <Box mt={3}>
          <Button
            onClick={handleForgotPasswordRequestSubmit}
            variant="contained"
          >
            Versturen
          </Button>
        </Box>
      </form>
    </>
  );
}

export default ForgotPasswordPage;

ForgotPasswordPage.propTypes = {};

ForgotPasswordPage.defaultProps = {};
